
const imageUrl = (title) => {
  return `/imgs/about/${title}.png`;
};

const banner = {
  title: '关于我们',
  description: '云恋科技，您身边的供应链专家。',
  bg: imageUrl('banner'),
};

const introduce = {
  description: '云恋科技为海格物流全资子公司，是海格云链的科技部分，目的是将海格的核心能力社会化；海格物流以创新为武器，积极稳健紧跟国际国内市场的发展，已发展成服务10000+家国内外大中型企业，年处理货值过1000亿的4A级知名供应链企业。',
  data: [
    {
      count: '10000+',
      description: '累计服务国内外大中型企业'
    },
    {
      count: '1000+亿',
      description: '年处理货值'
    },
  ]
};

const course = {
  description: '',
  data: [
    {
      year: '2001年',
      title: '公司成立',
      description: ''
    },
    {
      year: '2004年',
      title: '海格信息部成立',
      description: ''
    },
    {
      year: '2005年',
      title: '首推Milk-Run：',
      description: '获深圳市首个物流创新奖'
    },
    {
      year: '2008年',
      title: '启动逆向物流（RTV)服务：',
      description: '启动城际配送和国内长途干线服务；启动逆向物流（RTV)服务'
    },
    {
      year: '2011年',
      title: '启动First Mile (第一公里）',
      description: ''
    },
    {
      year: '2014年',
      title: '新三板挂牌：',
      description: 'Werner Global（美国沃纳）注册成为战略投资人；与IBM、Oracle、 Aon-Hew公司进行战略合作'
    },
    {
      year: '2016年',
      title: '云恋科技成立',
      description: ''
    },
    {
      year: '2017年',
      title: '大平台+小前端：',
      description: '深耕大平台+小前端模式；数据服务及供应链金融子公司业务稳步发展'
    },
    {
      year: '2019年',
      title: '与江苏省港口集团信息科技有限公司签署战略合同和框架协议；中标甘肃省物产集团兰州物流园有限公司供应链系统项目',
      description: ''
    }
  ]
};

const product = {
  description: '5大核心产品：物流控制塔（EPLD）+云恋科技运输管理系统（TMS）+云恋科技仓储管理系统（WMS）+数据中心+云ERP系统。',
  data: [
    {
      img: imageUrl('product1'),
      title: '物流控制塔（EPLD）',
      description: '全链全渠道供应链控制塔指挥系统',
      to: '/product/epld'
    },
    {
      img: imageUrl('product2'),
      title: '运输管理系统（TMS)',
      description: '运输全流程透明化，计费对账自动化',
      to: '/product/tms'
    },
    {
      img: imageUrl('product3'),
      title: '仓储管理系统（WMS)',
      description: '仓储管理可视化，计费对账自动化',
      to: '/product/wms'
    },
    {
      img: imageUrl('product4'),
      title: '数据中心',
      description: '数据可视化，智能分析，决策支持',
      to: '/product/dc'
    },
    {
      img: imageUrl('product5'),
      title: '云ERP系统',
      description: '提供全链条供应链服务优化',
      to: '/product/erp'
    }
  ]
};

const solution = {
  description: '3大核心解决方案：网络货运平台解决方案、综合物流服务解决方案、供应链金融系统解决方案。',
  data: [
    {
      img: imageUrl('solution1'),
      title: '网络货运平台',
      description: '平台搭建快速交付，资质代申请，解决进项获取难题，降低税负成本',
      to: '/solution/transport',
    },
    {
      img: imageUrl('solution2'),
      title: '综合物流服务',
      description: '提供智能化、平台化、数字化、信息化的多式联运综合物流解决方案',
      to: '/solution/logistics',
    },
    {
      img: imageUrl('solution3'),
      title: '供应链金融',
      description: '云恋供应链金融系统可为商贸和供应链企业提供四流合一的综合解决方案',
      to: '/solution/finance',
    },
  ]
};

const advantage = [
  {
    title: '我们的优势',
    subTitle: '系统、业务和资源的融合',
    img: imageUrl('advantage1'),
    items: [
      '我们的系统经过十多年研发反复迭代，与实际业务场景非常贴合；',
      '我们的团队是由具备十多年供应链和物流行业经验的业务专家和技术专家共同组成；',
      '我们的系统已经链接着全球10000多家甲方企业和国内400多家、国际1600多家物流供应商。'
    ]
  },
  {
    title: '我们的服务',
    subTitle: '资源齐全，省心省钱',
    img: imageUrl('advantage2'),
    items: [
      '标准产品+定制开发+运营管理经验输出+行业资源导入整合；',
      '标准SaaS服务即租即用；',
      '云恋供应链管家服务（LLP），与传统3pl相比，LLP只收取少量服务费用没有中间差价。'
    ]
  }
];

const copyright = {
  description: '计算机软件著作权。',
  data: imageUrl('copyright')
};

export {banner, introduce, course, product, solution, advantage, copyright};


// WEBPACK FOOTER //
// ./src/routes/About/config.js